import React, { Component } from 'react'
import styled from 'styled-components'
import CheckIcon from '../../../lib/assets/icons/check-white.svg'
import { BREAKPOINT, REGISTER_STAGE } from '../constants'

const STEP_TEXT = {
  CREATE_ACCOUNT: 'Create Account',
  CONFIRM_PROFILE: 'Confirm EHR Profile',
  EHR_CHECK: 'Suki-EHR Interface Check',
  GET_SUKI: 'Get Suki App'
}

const STEP_STATUS = {
  UNFINISHED: 'UNFINISHED',
  CURRENT: 'CURRENT',
  FINISHED: 'FINISHED'
}

// convert this to switch case

const getStageMap = (registerStage) => {
  switch (registerStage) {
    case REGISTER_STAGE.DEFAULT_STAGE:
      return []
    case REGISTER_STAGE.DEMO_EMAIL:
    case REGISTER_STAGE.DEMO_SUBMIT:
      return [{ status: STEP_STATUS.CURRENT, text: STEP_TEXT.CREATE_ACCOUNT },
        { status: STEP_STATUS.UNFINISHED, text: STEP_TEXT.CONFIRM_PROFILE },
        { status: STEP_STATUS.UNFINISHED, text: STEP_TEXT.EHR_CHECK },
        { status: STEP_STATUS.UNFINISHED, text: STEP_TEXT.GET_SUKI }]
    case REGISTER_STAGE.REGISTER_SUBMIT:
    case REGISTER_STAGE.EMR_SEARCH:
      return [
        { status: STEP_STATUS.FINISHED, text: STEP_TEXT.CREATE_ACCOUNT },
        { status: STEP_STATUS.CURRENT, text: STEP_TEXT.CONFIRM_PROFILE },
        { status: STEP_STATUS.UNFINISHED, text: STEP_TEXT.EHR_CHECK },
        { status: STEP_STATUS.UNFINISHED, text: STEP_TEXT.GET_SUKI }
      ]
    case REGISTER_STAGE.EMR_LINKED:
      return [
        { status: STEP_STATUS.FINISHED, text: STEP_TEXT.CREATE_ACCOUNT },
        { status: STEP_STATUS.FINISHED, text: STEP_TEXT.CONFIRM_PROFILE },
        { status: STEP_STATUS.CURRENT, text: STEP_TEXT.EHR_CHECK },
        { status: STEP_STATUS.UNFINISHED, text: STEP_TEXT.GET_SUKI }
      ]
    case REGISTER_STAGE.EMR_APPTS_VERIFIED:
    case REGISTER_STAGE.EMR_NOTES_VERIFIED:
    case REGISTER_STAGE.GET_SUKI:
      return [
        { status: STEP_STATUS.FINISHED, text: STEP_TEXT.CREATE_ACCOUNT },
        { status: STEP_STATUS.FINISHED, text: STEP_TEXT.CONFIRM_PROFILE },
        { status: STEP_STATUS.FINISHED, text: STEP_TEXT.EHR_CHECK },
        { status: STEP_STATUS.CURRENT, text: STEP_TEXT.GET_SUKI }
      ]
  }
}

const Container = styled.div`
  position: absolute;
  display: ${props => props.isScrolledDown ? 'none' : 'flex'};
  justify-content: center;
  width:100%;
  top: 30px;
  left: 80px;

  @media (max-width: ${BREAKPOINT.MEDIUM_LARGE}) {
    display:none;
  }
`

const Step = styled.div`
  position: relative;
  width: 200px;

  @media (max-width: 1000px){
    width: 180px !important;
  }

  div.line {
    position: absolute;
    top: 25px;
    left: 55px;
    height: 5px;
    background: ${props => props.status === STEP_STATUS.FINISHED ? '#2e5f62' : '#ddd'};
    width: calc(100% - 50px);

  }

  div.icon {
    display:flex;
    align-items: center;
    justify-content:center;
    position: absolute;
    left:5px;
    width: 45px;
    height: 45px;
    background: ${props => props.status === STEP_STATUS.UNFINISHED ? 'transparent' : '#2e5f62'};
    border-width: 3px;
    border-style: solid;

    border-color: ${props => props.status === STEP_STATUS.UNFINISHED ? '#ddd' : '#2e5f62'};
    border-radius: 50%;
    z-index: 1;
  }

  p {
    position: absolute;
    text-align: center;
    font-weight: 600;
    top: 45px;
    font-size: 14px;
    color: ${props => props.status === STEP_STATUS.UNFINISHED ? 'rgba(0, 0, 0, 0.5)' : '#2e5f62'};
    font-weight: ${props => props.status === STEP_STATUS.UNFINISHED ? 400 : 600};
    left: -28px;
    width: 110px;
  }
`

const SuccessIcon = styled.img.attrs({
  src: CheckIcon
})`
    width: 35px;
  `

class StepProgress extends Component {
  render () {
    const { registerStage, isScrolledDown } = this.props
    const stepData = getStageMap(registerStage)
    const stepRender = stepData.map((step, i) => {
      const { text, status } = step
      const isLast = stepData.length === i + 1
      return (
        <Step key={i} status={status}>
          <div className='icon'>
            {status === STEP_STATUS.FINISHED && <SuccessIcon />}
          </div>
          {!isLast && <div className='line' />}
          <p>{text}</p>
        </Step>
      )
    })
    return (
      <Container isScrolledDown={isScrolledDown}>
        {stepRender}
      </Container>
    )
  }
}

export default StepProgress
